import { Button } from 'react-bootstrap';
import { memo } from 'react';

import { ContentStyled } from './styled/ButtonArrowStyled';
import { Icon } from "../icon/Icon";

export const ButtonArrow = memo(({ children, className, ...buttonProps }) => (
    <Button variant="primary" size="lg" className={className} {...buttonProps}>
        <ContentStyled>
            {children}
            <Icon name="IcArrowRight" asComponent style={{ fontSize: "24px" }}/>
        </ContentStyled>
    </Button>
))